/**
 * Generated by orval v8.21.0 🍺
 * Do not edit manually.
 * FINRA Market Data API
 * Market data aggregation backend for FINRA data sources
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ContentGlobal,
  ContentPage,
  HTTPValidationError,
  InternalErrorResponse,
  UpstreamAuthenticationFailedErrorResponse,
  UpstreamBadGatewayErrorResponse,
  UpstreamUnavailableErrorResponse
} from '../fINRAMarketDataAPI.schemas.ts';

import { apiFetch } from '../../../lib/api-client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type getHomepageContentResponse200 = {
  data: ContentPage
  status: 200
}

export type getHomepageContentResponse500 = {
  data: UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse
  status: 500
}

export type getHomepageContentResponse502 = {
  data: UpstreamBadGatewayErrorResponse
  status: 502
}

export type getHomepageContentResponse503 = {
  data: UpstreamUnavailableErrorResponse
  status: 503
}

export type getHomepageContentResponseSuccess = (getHomepageContentResponse200) & {
  headers: Headers;
};
export type getHomepageContentResponseError = (getHomepageContentResponse500 | getHomepageContentResponse502 | getHomepageContentResponse503) & {
  headers: Headers;
};

export type getHomepageContentResponse = (getHomepageContentResponseSuccess | getHomepageContentResponseError)

export const getGetHomepageContentUrl = () => {




  return `/api/v1/content/homepage`
}

/**
 * @summary Get Homepage Content
 */
export const getHomepageContent = async ( options?: RequestInit): Promise<getHomepageContentResponse> => {

  return apiFetch<getHomepageContentResponse>(getGetHomepageContentUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetHomepageContentQueryKey = () => {
    return [
    `/api/v1/content/homepage`
    ] as const;
    }


export const getGetHomepageContentQueryOptions = <TData = Awaited<ReturnType<typeof getHomepageContent>>, TError = UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHomepageContent>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHomepageContentQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHomepageContent>>> = ({ signal }) => getHomepageContent({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHomepageContent>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetHomepageContentQueryResult = NonNullable<Awaited<ReturnType<typeof getHomepageContent>>>
export type GetHomepageContentQueryError = UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse


export function useGetHomepageContent<TData = Awaited<ReturnType<typeof getHomepageContent>>, TError = UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHomepageContent>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHomepageContent>>,
          TError,
          Awaited<ReturnType<typeof getHomepageContent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHomepageContent<TData = Awaited<ReturnType<typeof getHomepageContent>>, TError = UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHomepageContent>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHomepageContent>>,
          TError,
          Awaited<ReturnType<typeof getHomepageContent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHomepageContent<TData = Awaited<ReturnType<typeof getHomepageContent>>, TError = UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHomepageContent>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Homepage Content
 */

export function useGetHomepageContent<TData = Awaited<ReturnType<typeof getHomepageContent>>, TError = UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHomepageContent>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetHomepageContentQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type getGlobalContentResponse200 = {
  data: ContentGlobal
  status: 200
}

export type getGlobalContentResponse500 = {
  data: UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse
  status: 500
}

export type getGlobalContentResponse502 = {
  data: UpstreamBadGatewayErrorResponse
  status: 502
}

export type getGlobalContentResponse503 = {
  data: UpstreamUnavailableErrorResponse
  status: 503
}

export type getGlobalContentResponseSuccess = (getGlobalContentResponse200) & {
  headers: Headers;
};
export type getGlobalContentResponseError = (getGlobalContentResponse500 | getGlobalContentResponse502 | getGlobalContentResponse503) & {
  headers: Headers;
};

export type getGlobalContentResponse = (getGlobalContentResponseSuccess | getGlobalContentResponseError)

export const getGetGlobalContentUrl = () => {




  return `/api/v1/content/global`
}

/**
 * @summary Get Global Content
 */
export const getGlobalContent = async ( options?: RequestInit): Promise<getGlobalContentResponse> => {

  return apiFetch<getGlobalContentResponse>(getGetGlobalContentUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetGlobalContentQueryKey = () => {
    return [
    `/api/v1/content/global`
    ] as const;
    }


export const getGetGlobalContentQueryOptions = <TData = Awaited<ReturnType<typeof getGlobalContent>>, TError = UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGlobalContent>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGlobalContentQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGlobalContent>>> = ({ signal }) => getGlobalContent({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGlobalContent>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetGlobalContentQueryResult = NonNullable<Awaited<ReturnType<typeof getGlobalContent>>>
export type GetGlobalContentQueryError = UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse


export function useGetGlobalContent<TData = Awaited<ReturnType<typeof getGlobalContent>>, TError = UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGlobalContent>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGlobalContent>>,
          TError,
          Awaited<ReturnType<typeof getGlobalContent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGlobalContent<TData = Awaited<ReturnType<typeof getGlobalContent>>, TError = UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGlobalContent>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGlobalContent>>,
          TError,
          Awaited<ReturnType<typeof getGlobalContent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGlobalContent<TData = Awaited<ReturnType<typeof getGlobalContent>>, TError = UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGlobalContent>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Global Content
 */

export function useGetGlobalContent<TData = Awaited<ReturnType<typeof getGlobalContent>>, TError = UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGlobalContent>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetGlobalContentQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type getEquityDetailContentResponse200 = {
  data: ContentPage
  status: 200
}

export type getEquityDetailContentResponse500 = {
  data: UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse
  status: 500
}

export type getEquityDetailContentResponse502 = {
  data: UpstreamBadGatewayErrorResponse
  status: 502
}

export type getEquityDetailContentResponse503 = {
  data: UpstreamUnavailableErrorResponse
  status: 503
}

export type getEquityDetailContentResponseSuccess = (getEquityDetailContentResponse200) & {
  headers: Headers;
};
export type getEquityDetailContentResponseError = (getEquityDetailContentResponse500 | getEquityDetailContentResponse502 | getEquityDetailContentResponse503) & {
  headers: Headers;
};

export type getEquityDetailContentResponse = (getEquityDetailContentResponseSuccess | getEquityDetailContentResponseError)

export const getGetEquityDetailContentUrl = () => {




  return `/api/v1/content/equity-detail`
}

/**
 * @summary Get Equity Detail Content
 */
export const getEquityDetailContent = async ( options?: RequestInit): Promise<getEquityDetailContentResponse> => {

  return apiFetch<getEquityDetailContentResponse>(getGetEquityDetailContentUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetEquityDetailContentQueryKey = () => {
    return [
    `/api/v1/content/equity-detail`
    ] as const;
    }


export const getGetEquityDetailContentQueryOptions = <TData = Awaited<ReturnType<typeof getEquityDetailContent>>, TError = UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEquityDetailContent>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEquityDetailContentQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEquityDetailContent>>> = ({ signal }) => getEquityDetailContent({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEquityDetailContent>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEquityDetailContentQueryResult = NonNullable<Awaited<ReturnType<typeof getEquityDetailContent>>>
export type GetEquityDetailContentQueryError = UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse


export function useGetEquityDetailContent<TData = Awaited<ReturnType<typeof getEquityDetailContent>>, TError = UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEquityDetailContent>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEquityDetailContent>>,
          TError,
          Awaited<ReturnType<typeof getEquityDetailContent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEquityDetailContent<TData = Awaited<ReturnType<typeof getEquityDetailContent>>, TError = UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEquityDetailContent>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEquityDetailContent>>,
          TError,
          Awaited<ReturnType<typeof getEquityDetailContent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEquityDetailContent<TData = Awaited<ReturnType<typeof getEquityDetailContent>>, TError = UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEquityDetailContent>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Equity Detail Content
 */

export function useGetEquityDetailContent<TData = Awaited<ReturnType<typeof getEquityDetailContent>>, TError = UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEquityDetailContent>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEquityDetailContentQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type getETFDetailContentResponse200 = {
  data: ContentPage
  status: 200
}

export type getETFDetailContentResponse500 = {
  data: UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse
  status: 500
}

export type getETFDetailContentResponse502 = {
  data: UpstreamBadGatewayErrorResponse
  status: 502
}

export type getETFDetailContentResponse503 = {
  data: UpstreamUnavailableErrorResponse
  status: 503
}

export type getETFDetailContentResponseSuccess = (getETFDetailContentResponse200) & {
  headers: Headers;
};
export type getETFDetailContentResponseError = (getETFDetailContentResponse500 | getETFDetailContentResponse502 | getETFDetailContentResponse503) & {
  headers: Headers;
};

export type getETFDetailContentResponse = (getETFDetailContentResponseSuccess | getETFDetailContentResponseError)

export const getGetETFDetailContentUrl = () => {




  return `/api/v1/content/etf-detail`
}

/**
 * @summary Get Etf Detail Content
 */
export const getETFDetailContent = async ( options?: RequestInit): Promise<getETFDetailContentResponse> => {

  return apiFetch<getETFDetailContentResponse>(getGetETFDetailContentUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetETFDetailContentQueryKey = () => {
    return [
    `/api/v1/content/etf-detail`
    ] as const;
    }


export const getGetETFDetailContentQueryOptions = <TData = Awaited<ReturnType<typeof getETFDetailContent>>, TError = UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getETFDetailContent>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetETFDetailContentQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getETFDetailContent>>> = ({ signal }) => getETFDetailContent({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getETFDetailContent>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetETFDetailContentQueryResult = NonNullable<Awaited<ReturnType<typeof getETFDetailContent>>>
export type GetETFDetailContentQueryError = UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse


export function useGetETFDetailContent<TData = Awaited<ReturnType<typeof getETFDetailContent>>, TError = UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getETFDetailContent>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getETFDetailContent>>,
          TError,
          Awaited<ReturnType<typeof getETFDetailContent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetETFDetailContent<TData = Awaited<ReturnType<typeof getETFDetailContent>>, TError = UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getETFDetailContent>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getETFDetailContent>>,
          TError,
          Awaited<ReturnType<typeof getETFDetailContent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetETFDetailContent<TData = Awaited<ReturnType<typeof getETFDetailContent>>, TError = UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getETFDetailContent>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Etf Detail Content
 */

export function useGetETFDetailContent<TData = Awaited<ReturnType<typeof getETFDetailContent>>, TError = UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getETFDetailContent>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetETFDetailContentQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type getMutualFundDetailContentResponse200 = {
  data: ContentPage
  status: 200
}

export type getMutualFundDetailContentResponse500 = {
  data: UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse
  status: 500
}

export type getMutualFundDetailContentResponse502 = {
  data: UpstreamBadGatewayErrorResponse
  status: 502
}

export type getMutualFundDetailContentResponse503 = {
  data: UpstreamUnavailableErrorResponse
  status: 503
}

export type getMutualFundDetailContentResponseSuccess = (getMutualFundDetailContentResponse200) & {
  headers: Headers;
};
export type getMutualFundDetailContentResponseError = (getMutualFundDetailContentResponse500 | getMutualFundDetailContentResponse502 | getMutualFundDetailContentResponse503) & {
  headers: Headers;
};

export type getMutualFundDetailContentResponse = (getMutualFundDetailContentResponseSuccess | getMutualFundDetailContentResponseError)

export const getGetMutualFundDetailContentUrl = () => {




  return `/api/v1/content/mutual-fund-detail`
}

/**
 * @summary Get Mutual Fund Detail Content
 */
export const getMutualFundDetailContent = async ( options?: RequestInit): Promise<getMutualFundDetailContentResponse> => {

  return apiFetch<getMutualFundDetailContentResponse>(getGetMutualFundDetailContentUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMutualFundDetailContentQueryKey = () => {
    return [
    `/api/v1/content/mutual-fund-detail`
    ] as const;
    }


export const getGetMutualFundDetailContentQueryOptions = <TData = Awaited<ReturnType<typeof getMutualFundDetailContent>>, TError = UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMutualFundDetailContent>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMutualFundDetailContentQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMutualFundDetailContent>>> = ({ signal }) => getMutualFundDetailContent({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMutualFundDetailContent>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMutualFundDetailContentQueryResult = NonNullable<Awaited<ReturnType<typeof getMutualFundDetailContent>>>
export type GetMutualFundDetailContentQueryError = UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse


export function useGetMutualFundDetailContent<TData = Awaited<ReturnType<typeof getMutualFundDetailContent>>, TError = UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMutualFundDetailContent>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMutualFundDetailContent>>,
          TError,
          Awaited<ReturnType<typeof getMutualFundDetailContent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMutualFundDetailContent<TData = Awaited<ReturnType<typeof getMutualFundDetailContent>>, TError = UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMutualFundDetailContent>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMutualFundDetailContent>>,
          TError,
          Awaited<ReturnType<typeof getMutualFundDetailContent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMutualFundDetailContent<TData = Awaited<ReturnType<typeof getMutualFundDetailContent>>, TError = UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMutualFundDetailContent>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Mutual Fund Detail Content
 */

export function useGetMutualFundDetailContent<TData = Awaited<ReturnType<typeof getMutualFundDetailContent>>, TError = UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMutualFundDetailContent>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMutualFundDetailContentQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type getCategoryContentResponse200 = {
  data: ContentPage
  status: 200
}

export type getCategoryContentResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getCategoryContentResponse500 = {
  data: UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse
  status: 500
}

export type getCategoryContentResponse502 = {
  data: UpstreamBadGatewayErrorResponse
  status: 502
}

export type getCategoryContentResponse503 = {
  data: UpstreamUnavailableErrorResponse
  status: 503
}

export type getCategoryContentResponseSuccess = (getCategoryContentResponse200) & {
  headers: Headers;
};
export type getCategoryContentResponseError = (getCategoryContentResponse422 | getCategoryContentResponse500 | getCategoryContentResponse502 | getCategoryContentResponse503) & {
  headers: Headers;
};

export type getCategoryContentResponse = (getCategoryContentResponseSuccess | getCategoryContentResponseError)

export const getGetCategoryContentUrl = (category: string,) => {




  return `/api/v1/content/category/${category}`
}

/**
 * @summary Get Category Content
 */
export const getCategoryContent = async (category: string, options?: RequestInit): Promise<getCategoryContentResponse> => {

  return apiFetch<getCategoryContentResponse>(getGetCategoryContentUrl(category),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCategoryContentQueryKey = (category: string,) => {
    return [
    `/api/v1/content/category/${category}`
    ] as const;
    }


export const getGetCategoryContentQueryOptions = <TData = Awaited<ReturnType<typeof getCategoryContent>>, TError = HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(category: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoryContent>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCategoryContentQueryKey(category);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCategoryContent>>> = ({ signal }) => getCategoryContent(category, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: category !== null && category !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCategoryContent>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCategoryContentQueryResult = NonNullable<Awaited<ReturnType<typeof getCategoryContent>>>
export type GetCategoryContentQueryError = HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse


export function useGetCategoryContent<TData = Awaited<ReturnType<typeof getCategoryContent>>, TError = HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
 category: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoryContent>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCategoryContent>>,
          TError,
          Awaited<ReturnType<typeof getCategoryContent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCategoryContent<TData = Awaited<ReturnType<typeof getCategoryContent>>, TError = HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
 category: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoryContent>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCategoryContent>>,
          TError,
          Awaited<ReturnType<typeof getCategoryContent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCategoryContent<TData = Awaited<ReturnType<typeof getCategoryContent>>, TError = HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
 category: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoryContent>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Category Content
 */

export function useGetCategoryContent<TData = Awaited<ReturnType<typeof getCategoryContent>>, TError = HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
 category: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoryContent>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCategoryContentQueryOptions(category,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






